import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function MessagesTable() {
  const [msgs, setMsgs] = useState(null);

  const load = () => api.get("/admin/messages").then((r) => setMsgs(r.data)).catch(() => setMsgs([]));
  useEffect(() => {
    load();
  }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      await api.delete(`/admin/messages/${id}`);
      toast.success("Message deleted");
      load();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (msgs === null) return <p className="py-10 text-center text-sm text-muted-foreground">Loading…</p>;
  if (!msgs.length) return <p className="py-10 text-center text-sm text-muted-foreground" data-testid="messages-empty">No messages yet — submissions from the contact form will appear here.</p>;

  return (
    <div className="overflow-x-auto border border-border" style={{ borderRadius: "var(--radius)" }}>
      <table className="w-full text-sm" data-testid="messages-table">
        <thead>
          <tr className="border-b border-border text-xs uppercase tracking-wider text-muted-foreground">
            <th className="px-4 py-3 text-start">Name</th>
            <th className="px-4 py-3 text-start">Email</th>
            <th className="px-4 py-3 text-start">Type</th>
            <th className="px-4 py-3 text-start">Message</th>
            <th className="px-4 py-3 text-start">Date</th>
            <th className="px-4 py-3" />
          </tr>
        </thead>
        <tbody>
          {msgs.map((m, i) => (
            <tr key={m.id} className="border-b border-border/60" data-testid={`message-row-${i}`}>
              <td className="px-4 py-3 font-medium">{m.name}</td>
              <td className="px-4 py-3">{m.email}</td>
              <td className="px-4 py-3">{m.inquiry_type}</td>
              <td className="max-w-[22rem] px-4 py-3 text-muted-foreground">{m.message}</td>
              <td className="px-4 py-3 text-muted-foreground">{new Date(m.created_at).toLocaleDateString()}</td>
              <td className="px-4 py-3 text-end">
                <button data-testid={`message-delete-${i}`} onClick={() => remove(m.id)} className="text-xs text-destructive hover:underline">
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
